var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1427 35.6044V39.0215C76.1381 47.0311 73.5445 54.8246 68.7488 61.2397C63.953 67.6549 57.212 72.3479 49.5311 74.6189C41.8503 76.8899 33.641 76.6172 26.1278 73.8414C18.6146 71.0657 12.1999 65.9356 7.8405 59.2164C3.48107 52.4971 1.41044 44.5486 1.93745 36.5564C2.46445 28.5642 5.56085 20.9565 10.7648 14.8678C15.9688 8.77915 23.0016 4.53582 30.8142 2.77065C38.6269 1.00549 46.8008 1.81308 54.117 5.07297M76.1427 9.3073L38.9998 46.4873L27.8569 35.3444",
    stroke: "#19A3BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/loginImg.7bd9cf359259e78df5bf1bd00d5a95bf.svg";
export { ForwardRef as ReactComponent };